module.exports = __webpack_public_path__ + "img/brand_positioning_report.41f493cd.png";